import apiClient from "../helpers/ApiClient";

// --- VENUES ---
export const getEventVenues = async () => {
  const res = await apiClient.get("/events/venues");
  return res.data;
};

export const createEventVenue = async (data) => {
  const res = await apiClient.post("/events/venues", data);
  return res.data;
};

export const updateEventVenue = async (id, data) => {
  const res = await apiClient.put(`/events/venues/${id}`, data);
  return res.data;
};

export const checkVenueAvailability = async (venueId, startTime, endTime, excludeEventId = null) => {
  const res = await apiClient.get("/events/venues/availability", {
    params: {
      venue_id: venueId,
      start_time: startTime,
      end_time: endTime,
      exclude_event_id: excludeEventId
    }
  });
  return res.data;
};

// --- PACKAGES ---
export const getEventPackages = async () => {
  const res = await apiClient.get("/events/packages");
  return res.data;
};

export const createEventPackage = async (data) => {
  const res = await apiClient.post("/events/packages", data);
  return res.data;
};

export const updateEventPackage = async (id, data) => {
  const res = await apiClient.put(`/events/packages/${id}`, data);
  return res.data;
};

// --- MASTER EVENTS ---
export const getEvents = async (params = {}) => {
  const res = await apiClient.get("/events", { params });
  return res.data;
};

export const getEventDetails = async (id) => {
  const res = await apiClient.get(`/events/${id}`);
  return res.data;
};

export const createEventInquiry = async (data) => {
  const res = await apiClient.post("/events/inquiries", data);
  return res.data;
};

export const updateEvent = async (id, data) => {
  const res = await apiClient.put(`/events/${id}`, data);
  return res.data;
};

export const convertInquiryToBooking = async (id, data) => {
  const res = await apiClient.post(`/events/${id}/convert`, data);
  return res.data;
};

export const cancelEvent = async (id, data) => {
  const res = await apiClient.post(`/events/${id}/cancel`, data);
  return res.data;
};

// --- MULTI-FUNCTION SCHEDULES ---
export const createEventFunction = async (eventId, data) => {
  const res = await apiClient.post(`/events/${eventId}/functions`, data);
  return res.data;
};

export const deleteEventFunction = async (eventId, functionId) => {
  const res = await apiClient.delete(`/events/${eventId}/functions/${functionId}`);
  return res.data;
};

// --- QUOTATIONS ---
export const getAllQuotations = async (params = {}) => {
  const res = await apiClient.get("/events/quotations", { params });
  return res.data;
};

export const getQuotationDetails = async (quotationId) => {
  const res = await apiClient.get(`/events/quotations/${quotationId}`);
  return res.data;
};

export const createDirectQuotation = async (data) => {
  const res = await apiClient.post("/events/quotations", data);
  return res.data;
};

export const updateEventQuotation = async (quotationId, data) => {
  const res = await apiClient.put(`/events/quotations/${quotationId}`, data);
  return res.data;
};

export const createEventQuotation = async (eventId, data) => {
  const res = await apiClient.post(`/events/${eventId}/quotations`, data);
  return res.data;
};

export const approveEventQuotation = async (eventId, quotationId) => {
  if (eventId) {
    const res = await apiClient.post(`/events/${eventId}/quotations/${quotationId}/approve`);
    return res.data;
  }
  const res = await apiClient.post(`/events/quotations/${quotationId}/approve`);
  return res.data;
};

// --- BEO (BANQUET EVENT ORDER) ---
export const saveEventBeo = async (eventId, data) => {
  const res = await apiClient.post(`/events/${eventId}/beo`, data);
  return res.data;
};

// --- DEPARTMENT TASKS & COORDINATION ---
export const createEventDepartmentTask = async (eventId, data) => {
  const res = await apiClient.post(`/events/${eventId}/tasks`, data);
  return res.data;
};

export const updateEventDepartmentTaskStatus = async (eventId, taskId, status) => {
  const res = await apiClient.patch(`/events/${eventId}/tasks/${taskId}/status`, { status });
  return res.data;
};

export const issueEventLinen = async (eventId, data) => {
  const res = await apiClient.post(`/events/${eventId}/issue-linen`, data);
  return res.data;
};

export const addEventIncidentOrOvertime = async (eventId, data) => {
  const res = await apiClient.post(`/events/${eventId}/additional-charges`, data);
  return res.data;
};

// --- LIVE CHECKLIST ---
export const toggleChecklistItem = async (eventId, itemId, isCompleted) => {
  const res = await apiClient.patch(`/events/${eventId}/checklist/${itemId}`, { is_completed: isCompleted });
  return res.data;
};

// --- BILLING & DEPOSITS ---
export const recordEventPayment = async (eventId, data) => {
  const res = await apiClient.post(`/events/${eventId}/payments`, data);
  return res.data;
};

export const generateEventFinalInvoice = async (eventId, data) => {
  const res = await apiClient.post(`/events/${eventId}/generate-invoice`, data);
  return res.data;
};

// --- DASHBOARD, CALENDAR & REPORTS ---
export const getEventDashboardStats = async () => {
  const res = await apiClient.get("/events/dashboard-stats");
  return res.data;
};

export const getEventCalendarFeed = async (start, end) => {
  const res = await apiClient.get("/events/calendar-feed", { params: { start, end } });
  return res.data;
};

export const getEventReports = async (params = {}) => {
  const res = await apiClient.get("/events/reports", { params });
  return res.data;
};
